export * from "./models_0";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/client-cloudwatch-logs/dist/es/models/index.js
// module id = 1682
// module chunks = 0